import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { getImmersiveThumbUrl } from 'utils/http'

const AsideImmersiveItem = ({
  openImmersiveVideoHandler,
  title,
  file,
  vidExt,
  thumbExt,
  index,
  immersiveRef,
  setCurrentImmersiveRef,
}) => (
  <button
    ref={(btn) => (immersiveRef.current[index] = btn)}
    autoFocus={index === 0 ? true : false}
    className="immersive_item"
    onClick={() => {
      openImmersiveVideoHandler(`${file}.${vidExt}`)
      setCurrentImmersiveRef(index)
    }}
  >
    <div className="immersive_img_wrap">
      <img
        className="immersive_img"
        src={getImmersiveThumbUrl(`${file}.${thumbExt}`)}
        alt={title}
      />
    </div>
    <div className="immersive_title">{title}</div>
  </button>
)

export default AsideImmersiveItem

AsideImmersiveItem.propTypes = {
  openImmersiveVideoHandler: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  file: PropTypes.string.isRequired,
  vidExt: PropTypes.string.isRequired,
  thumbExt: PropTypes.string.isRequired,
}
